import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  fetchActiveTerminals,
  fetchWaitTimes,
  getItem,
  getLocations,
  setActiveLocation,
  setActiveState,
  setLocations,
  setLocationsPending,
  setStates,
} from '../store/rackWaitTimesSlice';

import Sidebar from './Sidebar';

const mapState = R.applySpec({
  locations: getLocations,
  locationsPending: getItem('locationsPending'),
  nonFilteredLocations: getItem('locations'),
});

const mapDispatchToProps = {
  fetchActiveTerminals,
  fetchWaitTimes,
  setActiveLocation,
  setActiveState,
  setLocations,
  setLocationsPending,
  setStates,
};

export default connect(mapState, mapDispatchToProps)(Sidebar);
